function getModifiedSrc(src) {
  if (src && src.startsWith('/media')) {
    return `${process.env.VUE_APP_MEDIA_BASE}${src}`;
  }
  return src;
}

export default {
  setGalleryItemsState(state, items) {
    state.items = items.map(item => {
      return {
        ...item,
        src: getModifiedSrc(item.src),
      };
    });
  },
  mutateGalleryItemState(state, {_id, ...data}) {
    state.items = state.items.map(item => {
      return item._id === _id ? {...item, ...data} : item;
    });
  },
  setGalleryMetaState(state, meta) {
    state.meta = meta;
  },
  setGalleryCurrentIndexState(state, index) {
    if (index >= 0 && index < state.items.length) {
      state.currentIndex = index;
    }
  },
  removeItemByIdFromGalleryState(state, id) {
    state.items = state.items.filter(item => item._id !== id);
    if (state.currentIndex !== null && !state.items[state.currentIndex]) {
      state.currentIndex = state.currentIndex > 0 ? state.currentIndex - 1 : null;
    }
  },
  setGalleryHighlightsVisibleState(state, ids) {
    state.highlightsVisible = ids;
  },
};
